import React, { useEffect } from 'react';
import { Container, Sponsor, Apoio, SponsorGrid, ApoioGrid } from './styles';

const apoios = [{ image: '/assets/evento/apoio/apmpa.jpg', url: '' }];

export const sponsors = [];

const FooterLayout: React.FC = ({ children }) => {
  return (
    <>
   
      <Container style={{background: '#fff'}}>
        <img src="/apoio/logos.png" style={{ margin: '0px auto', padding: '20px 0px', width: '100%', maxWidth: '1200px'}}/>
      </Container>
      <Container>
    

        <p style={{color: "#333"}}>
          Todos os direitos reservados - 2021
          <br />
          Website desenvolvido por
{' '}
          <a href="https://encontrodigital.com.br">
            Plataforma Encontro Digital
          </a>
        </p>
      </Container>
    </>
  );
};

export default FooterLayout;
